
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import PreschoolAcademicAssignmentsContent from "./components/PreschoolAcademicAssignmentsContent.vue";

export default defineComponent({
  name: "PreschoolAcademicAssignmentsContentPage",
  components: {
    BreadCrumb,
    PreschoolAcademicAssignmentsContent,
  },
});
